(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["box-builder-usp-bar"] && !Shopify.designMode) return;
  try {
    class BoxBuilderUspBar extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.box-builder__ticker-viewport');
      this.tracks = [...this.querySelectorAll('.box-builder__ticker-track')];
      if (!this.viewport || !this.tracks.length) return;

      this.sync = this.sync.bind(this);
      this.sync();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.sync);
        this.ro.observe(this.viewport);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.sync);
    }

    disconnectedCallback() {
      this.ro?.disconnect();
    }

    sync() {
      this.ensureClone();
      const width = this.tracks[0].scrollWidth;
      const speed = Math.max(10, Number(this.dataset.speed) || 60);
      this.style.setProperty('--bb-ticker-duration', `${(width / speed).toFixed(2)}s`);
    }

    ensureClone() {
      const existing = this.viewport.querySelector('[data-bb-tk-clone]');
      if (!existing && this.tracks.length === 1) {
        const clone = this.tracks[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-bb-tk-clone', '');
        this.viewport.appendChild(clone);
        this.tracks = [...this.querySelectorAll('.box-builder__ticker-track')];
      }
    }
  }

  if (!customElements.get('box-builder-usp-bar')) customElements.define('box-builder-usp-bar', BoxBuilderUspBar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    class ClearCartButton extends HTMLElement {
    connectedCallback() {
      this.querySelector('button')?.addEventListener('click', async () => {
        if (!window.confirm('Remove everything from your basket?')) return;
        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
        } catch (error) {
          // Reload regardless -- the cart page itself tells the truth either way.
        }
        window.location.reload();
      });
    }
  }
  if (!customElements.get('clear-cart-button')) customElements.define('clear-cart-button', ClearCartButton);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ff-account-auth"] && !Shopify.designMode) return;
  try {
    window.FFAccountAuth = window.FFAccountAuth || (function () {
    const SESSION_KEY = 'ff:account:oauth';
    const VERIFIER_KEY = 'ff:account:pkce-verifier';
    const STATE_KEY = 'ff:account:pkce-state';
    const RETURN_TO_KEY = 'ff:account:oauth-return-to';

    let config = null;
    function readConfig() {
      if (config) return config;
      const el = document.querySelector('[data-ff-account-auth-config]');
      try {
        config = el ? JSON.parse(el.textContent) : {};
      } catch (err) {
        config = {};
      }
      return config;
    }

    function base64url(bytes) {
      let str = '';
      bytes.forEach((b) => (str += String.fromCharCode(b)));
      return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    function randomVerifier() {
      const bytes = new Uint8Array(64);
      crypto.getRandomValues(bytes);
      return base64url(bytes);
    }

    async function challengeFromVerifier(verifier) {
      const data = new TextEncoder().encode(verifier);
      const digest = await crypto.subtle.digest('SHA-256', data);
      return base64url(new Uint8Array(digest));
    }

    function getSession() {
      try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        if (!raw) return null;
        const session = JSON.parse(raw);
        return session.expiresAt > Date.now() + 5000 ? session : null;
      } catch (err) {
        return null;
      }
    }

    // Starts the PKCE flow. With opts.silent, adds Shopify's own `prompt=none` -- confirmed
    // against Shopify's Customer Account API docs 2026-09-22: this NEVER shows a login screen,
    // it either returns a code straight away (an SSO session already exists) or comes straight
    // back with a `login_required` error (no session) -- there is no third outcome, so this is
    // safe to fire for a genuinely signed-out visitor too, unlike a plain (non-silent) beginAuth
    // call, which always shows Shopify's real hosted login form when no session exists. Records
    // the CURRENT page so handleOAuthReturn() (on /pages/account, the only registered redirect
    // URI) can bounce back here once the round trip completes, success or failure alike.
    async function beginAuth(opts) {
      const cfg = readConfig();
      if (!cfg.clientId || !cfg.authorizeUrl) return;
      const verifier = randomVerifier();
      const state = randomVerifier();
      const challenge = await challengeFromVerifier(verifier);
      sessionStorage.setItem(VERIFIER_KEY, verifier);
      sessionStorage.setItem(STATE_KEY, state);
      sessionStorage.setItem(RETURN_TO_KEY, window.location.pathname + window.location.search);

      const params = new URLSearchParams({
        client_id: cfg.clientId,
        response_type: 'code',
        redirect_uri: cfg.redirectUri,
        scope: 'openid email customer-account-api:full',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256',
      });
      if (opts && opts.silent) params.set('prompt', 'none');
      window.location.href = cfg.authorizeUrl + '?' + params.toString();
    }

    // Exchanges an OAuth return code for a session, if this page load carries one. Safe to run
    // alongside ff-account-overview.liquid's OWN independent copy of this same logic (both are
    // present on /pages/account, since the header renders everywhere) -- the code/state are read
    // and stripped from the URL synchronously, before anything async happens, so whichever of
    // the two runs first in execution order is the only one that ever sees a real code; the
    // other finds it already gone and no-ops. Nothing here changes those files or their storage.
    // Bounces the visitor back to whatever page a beginAuth() call was fired from, once the
    // round trip to Shopify's hosted authorize endpoint completes -- needed for BOTH outcomes
    // of a silent (prompt=none) call, not just success: a `login_required` failure (no SSO
    // session) still leaves the customer stranded on /pages/account, the only registered
    // redirect_uri, instead of the arbitrary page (home, PLP, a product page) they were
    // actually on when the silent check fired -- confirmed by reading through the redirect
    // contract below rather than live, since most visitors have no session and would hit
    // exactly this path on every fresh tab.
    function bounceToReturnPage() {
      const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
      if (returnTo && returnTo !== window.location.pathname + window.location.search) {
        sessionStorage.removeItem(RETURN_TO_KEY);
        window.location.replace(returnTo);
      }
    }

    async function handleOAuthReturn() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get('code');
      const state = url.searchParams.get('state');
      const error = url.searchParams.get('error');
      if (!code && !error) return;

      const expectedState = sessionStorage.getItem(STATE_KEY);
      const verifier = sessionStorage.getItem(VERIFIER_KEY);
      url.searchParams.delete('code');
      url.searchParams.delete('state');
      url.searchParams.delete('error');
      url.searchParams.delete('error_description');
      window.history.replaceState({}, '', url.toString());

      // `login_required` (or any other error) from a silent prompt=none call: nothing to
      // exchange, just return the visitor to where they started rather than leaving them on
      // /pages/account.
      if (error) { bounceToReturnPage(); return; }

      if (!verifier || !state || state !== expectedState) { bounceToReturnPage(); return; }

      const cfg = readConfig();
      try {
        let resp;
        if (cfg.tokenRelayUrl) {
          resp = await fetch(cfg.tokenRelayUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: code, code_verifier: verifier, redirect_uri: cfg.redirectUri }),
          });
        } else {
          resp = await fetch(cfg.authorizeUrl.replace('/oauth/authorize', '/oauth/token'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              grant_type: 'authorization_code',
              client_id: cfg.clientId,
              redirect_uri: cfg.redirectUri,
              code: code,
              code_verifier: verifier,
            }),
          });
        }
        const data = await resp.json();
        if (!resp.ok || !data.access_token) { bounceToReturnPage(); return; }

        sessionStorage.setItem(
          SESSION_KEY,
          JSON.stringify({ accessToken: data.access_token, idToken: data.id_token, expiresAt: Date.now() + data.expires_in * 1000 })
        );

        // sections/ff-header.liquid listens for this to re-check itself -- the OAuth
        // redirect_uri is this store's own /pages/account, so a customer can land back on
        // the exact page they started sign-in from with no navigation in between. The
        // header's own initial auth check, an independent script running on the same page
        // load, can complete before this exchange above finishes writing the session --
        // confirmed live 2026-09-19 as the cause of a header stuck on its logged-out/generic
        // state after a genuinely successful first sign-in, until some unrelated click
        // happened to trigger a fresh check elsewhere. This fires the instant a session
        // actually exists, closing that gap regardless of which side lost the race.
        document.dispatchEvent(new CustomEvent('ff:account:signed-in'));
        bounceToReturnPage();
      } catch (err) {
        // Nothing usable -- callers fall back to their own signed-out handling.
      }
    }

    // Runs once per page load: process a real OAuth return if this load carries one, then --
    // if this browser tab has no live session yet AND hasn't already tried a silent check --
    // fire ONE silent (prompt=none) check. Awaited (not fire-and-forget) so a caller that awaits
    // bootstrap() before reading getAccessToken() sees the freshly-exchanged token on the SAME
    // page load a code arrived on, not one load late.
    //
    // FAF001P-155, confirmed live 2026-09-22: the previous version of this gate only fired for
    // two narrow cases -- the classic `customer` Liquid object being populated (unreliable for
    // New Customer Accounts outside /pages/account, so blank on every other page including the
    // header) or a referrer containing "/checkouts/". A customer signed in through any OTHER
    // route (the header's own "Log in" link to /pages/account, the Shop App, an email link)
    // got a correct header on /pages/account itself, where the real sign-in flow's own
    // ff:account:signed-in dispatch covers it, but every OTHER page they then visited stayed
    // stuck showing signed-out -- nothing on those pages ever re-checked, until they happened
    // to land back on /pages/account or checkout again ("after around five minutes of clicking
    // around the site").
    //
    // `prompt=none` (Shopify's own Customer Account API parameter, confirmed via shopify.dev
    // 2026-09-22) is what makes firing this on every page safe: it NEVER shows a login screen,
    // full stop -- either an SSO session already exists and it resolves silently, or it fails
    // fast with a `login_required` redirect straight back (handleOAuthReturn()'s bounceToReturnPage()
    // above returns the visitor to the exact page they were on either way). A hidden iframe would
    // avoid even that redirect round trip, but Shopify's own authorize endpoint sends
    // `X-Frame-Options: DENY` / `frame-ancestors 'none'` (confirmed live 2026-09-22, curl against
    // the real authorize URL) -- embedding it is blocked outright, not a choice. So this still
    // costs one visible URL-bar round trip -- never a login form, just a brief navigate-away-and-
    // back -- which is why it fires at most ONCE per tab (the sessionStorage flag below), not on
    // every page: a signed-out visitor browsing several pages in one tab pays that cost once,
    // not repeatedly, while a signed-in one gets picked up on their very next page view.
    const SILENT_CHECK_KEY = 'ff:account:silent-checked';
    let bootstrapped = null;
    function bootstrap() {
      if (bootstrapped) return bootstrapped;
      bootstrapped = (async () => {
        await handleOAuthReturn();
        // DISABLED 2026-09-24 -- confirmed live: a brand new visitor, with no existing
        // Shopify session at all, landed on a REAL, interactive shopify.com sign-in FORM
        // on their very first page load, not the invisible silent check this was designed
        // to be. The captured redirect URL had no prompt=none parameter anywhere on it,
        // despite beginAuth({silent:true}) below unconditionally setting one -- so either
        // Shopify's /login endpoint isn't honouring prompt=none the way the comment above
        // (and the shopify.dev research it cites) assumed, or something strips it before
        // the form renders. Whichever it is, the practical effect was every new visitor
        // hitting a login wall on arrival -- far worse than the stale-header problem this
        // was solving (FAF001P-155). Stopping the bleeding here; a real fix needs to
        // understand why prompt=none isn't suppressing the form before this comes back on,
        // not just re-enable it and hope.
        // if (!getSession() && !sessionStorage.getItem(SILENT_CHECK_KEY)) {
        //   sessionStorage.setItem(SILENT_CHECK_KEY, '1');
        //   await beginAuth({ silent: true });
        // }
      })();
      return bootstrapped;
    }

    return {
      bootstrap,
      // Exposed so any page can offer a direct "sign in again" action when it detects an
      // expired/missing session itself (e.g. blocks/ff-box-builder.liquid's existing-box
      // load failing after a period of inactivity) -- this is the SAME function the disabled
      // silent check above would have called, just reachable directly, non-silent (no
      // `opts.silent`), so it's a real, visible sign-in redirect that records the current
      // page as RETURN_TO_KEY and bounces back here once it completes.
      beginAuth,
      getAccessToken() {
        const session = getSession();
        return session ? session.accessToken : null;
      },
      // Drop-in replacement for window.recharge.auth.loginShopifyAppProxy() at this theme's
      // other Recharge call sites -- returns the same Session shape (apiToken/customerId), so
      // nothing downstream of the call needs to change. Callers must already have called
      // window.recharge.init() themselves, exactly as before.
      //
      // Cached per page load, same shape as _rcReady/_subscriptionsPromise below: this method
      // is called directly and independently by ff-header.liquid (twice) and
      // blocks/ff-box-builder.liquid, all around the same moment on page load, with no
      // coordination between them. Each uncached call hit Recharge's own
      // loginWithShopifyCustomerAccount() separately -- confirmed live 2026-09-19 that this
      // endpoint rejects a concurrent call for the same session much like the charge/
      // subscription write endpoints do ("a call to this route is already in progress"),
      // so two callers landing at the same moment meant one of them failed for no reason
      // other than the other one also asking. A single shared promise means every caller
      // gets the same one real login, however many of them ask for it.
      _loginPromise: null,
      async loginToRecharge() {
        const token = this.getAccessToken();
        if (!token) return null;
        if (this._loginPromise) return this._loginPromise;
        this._loginPromise = (async () => {
          try {
            return await window.recharge.auth.loginWithShopifyCustomerAccount(token);
          } catch (err) {
            this._loginPromise = null;
            return null;
          }
        })();
        return this._loginPromise;
      },
      // Same Customer Account API GraphQL call sections/ff-account-overview.liquid already
      // makes for its own name display -- exposed here so any page can show a real name
      // without duplicating a fetch call at every site that wants one. Cached per page load
      // (token doesn't change mid-session), null on any failure or no session.
      _namePromise: null,
      async getCustomerFirstName() {
        const token = this.getAccessToken();
        if (!token) return null;
        if (this._namePromise) return this._namePromise;
        const cfg = readConfig();
        this._namePromise = fetch(cfg.graphqlUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: token },
          body: JSON.stringify({ query: '{ customer { firstName } }' }),
        })
          .then((resp) => resp.json())
          .then((data) => data?.data?.customer?.firstName || null)
          .catch(() => null);
        return this._namePromise;
      },
      // Loads and initialises the Recharge SDK itself -- unlike loginToRecharge(), which
      // assumes a caller already did this (matching every existing Recharge call site in
      // this theme), this is meant to be usable from anywhere with no other component
      // involved, which is the whole point of a single shared subscription check.
      // `if (window.recharge) return` used to sit here as a first check, on the assumption
      // that the global existing meant Recharge was ready to use. It doesn't: ff-header.liquid
      // and blocks/ff-box-builder.liquid each load and `init()` their own copy of this same
      // SDK independently (this theme's own documented "no shared module" convention), and the
      // moment ANY of those scripts' <script> tags finishes loading, `window.recharge` exists
      // as an object even though that script's own `init()` call may still be in flight. A
      // caller here that saw the global and returned immediately went straight to
      // loginWithShopifyCustomerAccount() against an SDK that was not actually configured yet
      // for anyone. Confirmed live 2026-09-19: the exact same access token succeeded when
      // window.recharge.auth.loginWithShopifyCustomerAccount() was called directly moments
      // later, and failed silently (caught, returned null) when routed through this guard --
      // this is a race, not a broken token. The `_rcReady` promise below is the only guard
      // this function needs: it is unique to and awaited by every caller of this SAME file's
      // own methods, so it is never satisfied by a different script's unrelated init() call.
      // A caller here always drives its own load-and-init to completion instead of trusting
      // someone else's — Recharge's own init() is safe to call more than once for the same
      // store, so a second, redundant SDK load elsewhere on the page is wasted bandwidth, not
      // a correctness risk.
      _rcReady: null,
      async _ensureRecharge() {
        if (this._rcReady) return this._rcReady;
        const cfg = readConfig();
        this._rcReady = new Promise((resolve, reject) => {
          // await, not .then() chained straight off the call: every other Recharge call site
          // in this theme awaits window.recharge.init(...) rather than assuming its return
          // value is directly thenable -- confirmed live 2026-09-15 that assuming so throws
          // "Cannot read properties of undefined (reading 'then')" here.
          const finishInit = async () => {
            try {
              await window.recharge.init({
                storeIdentifier: cfg.shopDomain,
                storefrontAccessToken: cfg.rechargeStorefrontToken,
                appName: 'FFAccountAuth',
                appVersion: '1.0.0',
              });
              resolve();
            } catch (err) {
              reject(err);
            }
          };

          // blocks/ff-box-builder.liquid already renders this exact script statically (with
          // `defer`) on its own page. Reusing that tag instead of inserting a second one
          // avoids downloading and re-executing the whole SDK twice on that page -- measured
          // live on /products/your-box as a real, avoidable chunk of load time. Every OTHER
          // page (header, PLP, product page) has no such tag, so this still falls back to
          // loading its own copy exactly as before -- init() itself is still always called
          // here regardless of which script produced window.recharge, per the note above.
          const existing = document.querySelector('script[src*="recharge-client"]');
          if (existing) {
            if (window.recharge) {
              finishInit();
            } else {
              existing.addEventListener('load', finishInit, { once: true });
              existing.addEventListener('error', () => reject(new Error('recharge_sdk_failed')), { once: true });
            }
            return;
          }

          const el = document.createElement('script');
          el.src = 'https://static.rechargecdn.com/assets/storefront/recharge-client-' + (cfg.rechargeSdkVersion || '1.51.0') + '.min.js';
          el.onload = finishInit;
          el.onerror = () => reject(new Error('recharge_sdk_failed'));
          document.head.appendChild(el);
        });
        return this._rcReady;
      },
      // The single site-wide source of truth for "what are this customer's active
      // subscriptions" -- every place that used to read has_subscription (server-side, from
      // customer.tags -- unreliable, see this file's own doc comment) or ran its OWN
      // loginToRecharge() + listSubscriptions() call (blocks/ff-box-builder.liquid had three
      // separate copies of that before this method existed) should call this instead. Cached
      // for the page's lifetime after the first real call, keyed by nothing (one customer per
      // page load) -- every caller, whatever they're checking, shares the same one real
      // network round trip and therefore the same answer. Two independent callers computing
      // this separately is exactly how the header and Box Builder disagreed with each other
      // about the same customer's subscription status on the same page load, confirmed live
      // 2026-09-15, before this consolidation.
      async _fetchActiveSubscriptionsOnce() {
        const token = this.getAccessToken();
        if (!token) return [];
        await this._ensureRecharge();
        const auth = await this.loginToRecharge();
        if (!auth?.apiToken || !auth?.customerId) return [];
        const { subscriptions } = await window.recharge.subscription.listSubscriptions(auth, {
          customer_id: auth.customerId,
          status: 'active',
        });
        // Confirmed live 2026-09-20: `status: 'active'` here is a request filter, not a
        // guarantee -- a subscription cancelled moments earlier (e.g. via Recharge's own
        // hosted churn flow, redirecting straight back to this store) can still come back
        // in this response. Without this, blocks/ff-box-builder.liquid's
        // detectClientSideSubscription() saw a real match, flipped into 'edit' mode for a
        // subscription that no longer exists to edit, and confirmChanges() then failed
        // against Recharge with "purchaseItemId and a non-empty items array are required"
        // -- a customer trying to start a FRESH box after cancelling got stuck unable to
        // do either. sections/ff-manage-subscription.liquid's own resolveSubscription()
        // already re-filters this exact way; this shared method, used by every OTHER
        // caller (the header, the box builder, account overview), didn't.
        return (subscriptions || []).filter((sub) => !(sub.status && /cancel/i.test(sub.status)));
      },
      // The Recharge plan id for the frequency a subscription runs on, read from the box
      // product's own selling plan groups (option 'Recharge Plan ID' on each group, matched
      // on 'Order Frequency and Unit', for example '2-week').
      // Every write to a box's Bundle Selection must send it as `plan_id`. Without it
      // Recharge reprices every item in the box at the one-time price on any edit, which is
      // the discount that was lost after a customer changed their box. Recharge rejects a
      // Shopify selling plan id here ('Plan does not exist'), and rejects a per-item `price`
      // ('This bundle does not allow customizing prices'), so this is the supported route.
      // Never throws: null means no plan id could be resolved, and callers then write exactly
      // as they did before.
      _bundleDataByProduct: {},
      async getRechargePlanId(subscription, boxProductId) {
        try {
          if (!subscription || !boxProductId) return null;
          await this._ensureRecharge();
          const key = String(boxProductId);
          if (!this._bundleDataByProduct[key]) {
            this._bundleDataByProduct[key] = window.recharge.bundleData.loadBundleData(boxProductId).catch((err) => {
              delete this._bundleDataByProduct[key];
              throw err;
            });
          }
          const data = await this._bundleDataByProduct[key];
          const freq = Number(subscription.order_interval_frequency);
          const unit = subscription.order_interval_unit;
          const option = (group, name) => group.options?.find((o) => o.name === name)?.values?.[0];
          for (const group of data?.selling_plan_groups || []) {
            const match = String(option(group, 'Order Frequency and Unit') || '').match(/^(\d+)-(\w+)/);
            if (match && Number(match[1]) === freq && match[2] === unit) {
              const id = Number(option(group, 'Recharge Plan ID'));
              return id || null;
            }
          }
          return null;
        } catch (err) {
          return null;
        }
      },
      _subscriptionsPromise: null,
      async getActiveSubscriptions() {
        if (this._subscriptionsPromise) return this._subscriptionsPromise;
        this._subscriptionsPromise = (async () => {
          const withTimeout = (promise) =>
            Promise.race([promise, new Promise((_, reject) => setTimeout(() => reject(new Error('recharge_timeout')), 20000))]);
          try {
            let subs = await withTimeout(this._fetchActiveSubscriptionsOnce());
            // Recharge's own session needs a brief moment to fully establish right after
            // loginWithShopifyCustomerAccount() -- confirmed live 2026-09-15: querying too
            // soon after returns an empty (not wrong, just not-yet-consistent) result; the
            // IDENTICAL query, run again moments later with no other change, succeeds. One
            // bounded retry after a short pause, only when the first attempt came back
            // empty, so a genuinely unsubscribed visitor (the common case, site-wide) never
            // pays this delay -- only an actual subscriber whose first check landed in that
            // narrow post-login window does.
            if (subs.length === 0) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              subs = await withTimeout(this._fetchActiveSubscriptionsOnce());
            }
            return subs;
          } catch (err) {
            // A stuck request here (a slow response, a throttled background tab) must not
            // poison this promise for the page's whole remaining lifetime -- clear the cache
            // field so the next caller gets a fresh attempt instead of inheriting this one.
            this._subscriptionsPromise = null;
            return [];
          }
        })();
        return this._subscriptionsPromise;
      },
      // Convenience wrapper: the specific subscription for a product, or undefined. Every
      // subscription-matching call site in this theme already uses this exact shape --
      // sub.external_product_id is an object, { ecommerce: "<id>" }, not a plain string/number
      // like everywhere else (cart lines, bundle selection items).
      async getSubscriptionForProduct(productId) {
        const subscriptions = await this.getActiveSubscriptions();
        return subscriptions.find((sub) => String(sub.external_product_id?.ecommerce) === String(productId));
      },
      // productId omitted: true if the customer has ANY active subscription. Passed: true
      // only if one of them is for that specific product.
      async hasActiveSubscription(productId) {
        if (!productId) return (await this.getActiveSubscriptions()).length > 0;
        return !!(await this.getSubscriptionForProduct(productId));
      },
      // Corrects every [data-ff-visibility="logged_in"|"logged_out"] element under `root`
      // (default document) once this page load's real auth state is known. Liquid can only
      // guess at that state server-side -- the classic `customer` object this theme's sections
      // read for their own SSR-time default is unreliable for New Customer Accounts outside
      // /pages/account (see this file's own doc comment), so every section using this data
      // attribute renders its best guess first (hidden for "logged in only" content, since
      // hide-then-reveal is this theme's established pattern elsewhere, e.g.
      // sections/ff-product-page.liquid's reviews row) and this corrects it once bootstrap()
      // resolves. Auto-run once below rather than left for each section to call: bootstrap()
      // is already cached/shared, and a section opting into this attribute needs nothing more
      // than the attribute itself.
      // FAF001P-234: "logged in" is either signal. The tab token only exists after a sign-in
      // through /pages/account in this tab, so on its own it called a customer who is signed
      // in to Shopify (fresh tab, email link) logged out and overrode the server's correct
      // answer. The server's `customer` flag (config.customerLoggedIn) is the other signal.
      // Whole-section gates (snippets/ff-section-visibility.liquid) carry
      // data-ff-visibility-section and flip their data-ff-state instead of `hidden`, and are
      // left alone in the theme editor so a merchant can still edit a gated section.
      applyVisibility(root) {
        const loggedIn = !!this.getAccessToken() || !!readConfig().customerLoggedIn;
        const designMode = !!(window.Shopify && window.Shopify.designMode);
        (root || document).querySelectorAll('[data-ff-visibility]').forEach((el) => {
          const mode = el.getAttribute('data-ff-visibility');
          const show = mode === 'logged_in' ? loggedIn : mode === 'logged_out' ? !loggedIn : true;
          if (el.hasAttribute('data-ff-visibility-section')) {
            el.setAttribute('data-ff-state', show || designMode ? 'show' : 'hide');
          } else {
            el.hidden = !show;
          }
        });
      },
    };
  })();

  window.FFAccountAuth.bootstrap().then(() => window.FFAccountAuth.applyVisibility());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ff-delivery-countdown"] && !Shopify.designMode) return;
  try {
    class FFDeliveryCountdown extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-countdown-text]');
      this.leadEl = this.querySelector('[data-countdown-lead]');
      this.timeEl = this.querySelector('[data-countdown-time]');
      this.midEl = this.querySelector('[data-countdown-mid]');
      this.dateEl = this.querySelector('[data-countdown-date]');
      this.tailEl = this.querySelector('[data-countdown-tail]');
      this.resolve();
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      this._flareObserver?.disconnect();
      this._flareObserver = null;
    }

    hide(state) {
      clearInterval(this._timer);
      this.dataset.countdownState = state;
      this.hidden = true;
      this.closest('ff-product-page')?.removeAttribute('data-ff-countdown-live');
    }

    resolve() {
      if (!this.textEl) return;

      const source = this.dataset.countdownSource || 'flare';
      if (source === 'off') return this.hide('off');

      if (source === 'flare') this.refreshFlareAttributes();

      let resolved = null;
      let resolvedVia = '';
      if (source === 'flare') {
        resolved = this.fromFlare();
        resolvedVia = 'flare';
        if (!resolved) {
          resolved = this.fromFlareConfig();
          resolvedVia = 'flare-config';
        }
        if (!resolved) this.watchFlareBlock();
      } else {
        resolved = this.fromSettings();
        resolvedVia = 'manual-estimate';
      }
      if (!resolved) return this.hide(source === 'flare' ? 'hidden-no-flare-data' : 'hidden-invalid-settings');

      const { deadline, deliveryDate } = resolved;
      const deliveryLabel = deliveryDate.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });

      const tick = () => {
        const remainingMs = deadline - Date.now();
        if (remainingMs <= 0) {
          clearInterval(this._timer);
          this.hide('hidden-deadline-passed');
          this._rolls = (this._rolls || 0) + 1;
          if (this._rolls <= 3) {
            setTimeout(() => { if (this.isConnected) this.resolve(); }, 1500);
          }
          return;
        }
        this._rolls = 0;
        const hours = Math.floor(remainingMs / 3_600_000);
        const minutes = Math.floor((remainingMs % 3_600_000) / 60_000);
        const seconds = Math.floor((remainingMs % 60_000) / 1000);
        const remaining = `${hours}h ${minutes}m ${seconds}s`;
        if (this.timeEl && this.dateEl) {
          this.leadEl.textContent = 'Order in ';
          this.timeEl.textContent = remaining;
          this.midEl.textContent = this.dataset.midText || ' for delivery on ';
          this.dateEl.textContent = deliveryLabel;
          if (this.tailEl) this.tailEl.textContent = this.dataset.tailText || '';
        } else {
          this.textEl.textContent = `Order in ${remaining} for delivery on ${deliveryLabel}`;
        }
      };

      this.hidden = false;
      this.dataset.countdownState = resolvedVia;
      tick();
      if (this.hidden) return;
      this.closest('ff-product-page')?.setAttribute('data-ff-countdown-live', 'true');
      clearInterval(this._timer);
      this._timer = setInterval(tick, 1000);
    }

    fromFlare() {
      const deadline = FFDeliveryCountdown.parseInstant(this.dataset.flareCutoffDeadline);
      if (!deadline) return null;

      const remainingMs = deadline - Date.now();
      const MAX_AHEAD_MS = 14 * 24 * 3_600_000;
      if (remainingMs <= 0 || remainingMs > MAX_AHEAD_MS) return null;

      const deliveryDate = FFDeliveryCountdown.parseInstant(this.dataset.flareDeliveryDate);
      if (!deliveryDate) return null;

      return { deadline, deliveryDate };
    }

    fromFlareConfig() {
      const cfg = window.flareGlobalConfig;
      if (!cfg) return null;

      const configs = Array.isArray(cfg.cutoffConfigs) ? cfg.cutoffConfigs : [];
      const cut =
        configs.find((c) => c && c.enabled && c.type === 'all') ||
        configs.find((c) => c && c.enabled) ||
        (cfg.cutoffConfig && cfg.cutoffConfig.enabled ? cfg.cutoffConfig : null);
      if (!cut || typeof cut.time !== 'string' || !/^\d{1,2}:\d{2}$/.test(cut.time)) return null;

      const deadline = FFDeliveryCountdown.nextCutoff(cut.time, cut.timezone, cut.daysOfWeek);
      if (!deadline) return null;

      const deliveryDate = FFDeliveryCountdown.flareRenderedDate(cfg);
      if (!deliveryDate) return null;

      const daysAhead = (deliveryDate.getTime() - Date.now()) / 86400000;
      const max = Number(cfg.maximumDaysAhead);
      if (daysAhead < -1) return null;
      if (Number.isFinite(max) && max > 0 && daysAhead > max) return null;
      if (deadline.getTime() > deliveryDate.getTime() + 86400000) return null;

      return { deadline, deliveryDate };
    }

    static zonedInstant(year, month, day, hour, minute, timeZone) {
      const naive = Date.UTC(year, month, day, hour, minute, 0);
      if (!timeZone) return new Date(naive);
      let guess = naive;
      for (let i = 0; i < 2; i += 1) {
        let parts;
        try {
          parts = new Intl.DateTimeFormat('en-GB', {
            timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
          }).formatToParts(new Date(guess));
        } catch (error) {
          return new Date(naive);
        }
        const p = Object.fromEntries(
          parts.filter((x) => x.type !== 'literal').map((x) => [x.type, Number(x.value)])
        );
        const back = Date.UTC(p.year, p.month - 1, p.day, p.hour === 24 ? 0 : p.hour, p.minute, p.second);
        guess += naive - back;
      }
      return new Date(guess);
    }

    static nextCutoff(time, timeZone, daysOfWeek) {
      const [hour, minute] = time.split(':').map(Number);
      if (!Number.isInteger(hour) || hour < 0 || hour > 23) return null;
      if (!Number.isInteger(minute) || minute < 0 || minute > 59) return null;

      const NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const allowed = (d) => {
        if (!daysOfWeek || typeof daysOfWeek !== 'object') return true;
        const value = daysOfWeek[NAMES[d.getDay()]];
        return value === undefined ? true : !!value;
      };

      const now = new Date(Date.now());
      for (let i = 0; i < 14; i += 1) {
        const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
        if (!allowed(day)) continue;
        const instant = FFDeliveryCountdown.zonedInstant(
          day.getFullYear(), day.getMonth(), day.getDate(), hour, minute, timeZone
        );
        if (instant.getTime() > now.getTime()) return instant;
      }
      return null;
    }

    static flareRenderedDate(cfg) {
      const node = document.getElementById('flare-est-stock') || document.getElementById('flare-est-date');
      const raw = (node?.textContent || '').trim();
      if (!raw) return null;

      const text = cfg && cfg.textContent
        ? Object.values(cfg.textContent).reduce(
            (acc, line) => (typeof line === 'string' && line ? acc.split(line).join(' ') : acc), raw
          )
        : raw;

      const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
      const lower = text.toLowerCase();
      let month = -1;
      let at = Infinity;
      MONTHS.forEach((name, index) => {
        const found = lower.indexOf(name);
        if (found !== -1 && found < at) { at = found; month = index; }
      });
      if (month < 0) return null;

      const dayMatch = text.match(/\b(\d{1,2})(?:st|nd|rd|th)?\b/);
      const day = dayMatch ? Number(dayMatch[1]) : NaN;
      if (!Number.isInteger(day) || day < 1 || day > 31) return null;

      const now = new Date(Date.now());
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      for (const year of [now.getFullYear(), now.getFullYear() + 1]) {
        const candidate = new Date(year, month, day);
        if (candidate.getMonth() !== month) continue;
        if (candidate.getTime() >= today.getTime()) return candidate;
      }
      return null;
    }

    watchFlareBlock() {
      if (this._flareObserver) return;
      const block = document.querySelector('[data-block="flare-earliest-delivery"]');
      if (!block) return;
      this._flareObserver = new MutationObserver(() => {
        if (!this.isConnected) return;
        if (this.fromFlareConfig()) {
          this._flareObserver.disconnect();
          this._flareObserver = null;
          this.resolve();
        }
      });
      this._flareObserver.observe(block, { childList: true, subtree: true, characterData: true });
      setTimeout(() => {
        this._flareObserver?.disconnect();
        this._flareObserver = null;
      }, 15000);
    }

    fromSettings() {
      const parts = String(this.dataset.cutoffTime || '').split(':');
      const hour = Number(parts[0]);
      const minute = Number(parts[1]);
      const leadDays = Number(this.dataset.leadDays);
      if (!Number.isInteger(hour) || hour < 0 || hour > 23) return null;
      if (!Number.isInteger(minute) || minute < 0 || minute > 59) return null;
      if (!Number.isInteger(leadDays) || leadDays < 0) return null;

      const now = new Date(Date.now());
      const deadline = new Date(now);
      deadline.setHours(hour, minute, 0, 0);
      if (deadline <= now) deadline.setDate(deadline.getDate() + 1);

      const deliveryDate = new Date(deadline);
      deliveryDate.setDate(deliveryDate.getDate() + leadDays);
      return { deadline, deliveryDate };
    }

    refreshFlareAttributes() {
      if (FFDeliveryCountdown.cartAttributes) {
        const { cutoff, delivery } = FFDeliveryCountdown.cartAttributes;
        if (cutoff !== undefined) this.dataset.flareCutoffDeadline = cutoff || '';
        if (delivery !== undefined) this.dataset.flareDeliveryDate = delivery || '';
        return;
      }
      if (FFDeliveryCountdown.cartFetch) {
        FFDeliveryCountdown.cartFetch.then(() => { if (this.isConnected) this.resolve(); });
        return;
      }
      FFDeliveryCountdown.cartFetch = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          const attributes = cart?.attributes || {};
          FFDeliveryCountdown.cartAttributes = {
            cutoff: attributes.__flare_cutoff_deadline,
            delivery: attributes.__flare_delivery_date,
          };
          if (this.isConnected) this.resolve();
        })
        .catch(() => {
        });
    }

    static parseInstant(raw) {
      const value = (raw || '').trim();
      if (!value) return null;
      const parsed = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
  }

  if (!customElements.get('ff-delivery-countdown')) {
    customElements.define('ff-delivery-countdown', FFDeliveryCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ff-product-card"] && !Shopify.designMode) return;
  try {
    class FFProductCard extends HTMLElement {
    connectedCallback() {
      if (this.__ffBound) return;
      this.__ffBound = true;

      for (const quickViewTrigger of this.querySelectorAll('[data-ff-quick-view]')) {
        quickViewTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.dispatchEvent(new CustomEvent('ff:product-card:quick-view', {
            bubbles: true,
            detail: { productId: quickViewTrigger.dataset.productId },
          }));
        });
      }

      this.form = this.querySelector('.ff-product-card__form');
      if (!this.form) return;

      this.addBtn = this.querySelector('[data-ff-add]');
      this.box = this.querySelector('[data-ff-box]');
      this.qtyEl = this.querySelector('[data-ff-qty]');
      this.priceEl = this.querySelector('[data-ff-price]');
      this.servesEl = this.querySelector('[data-ff-serves]');
      this.servesLabel = this.querySelector('[data-ff-serves-label]');
      this.errorEl = this.querySelector('[data-ff-error]');

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.mutate('add', 1);
      });

      this.form.addEventListener('change', (event) => {
        if (event.target.name === 'id') this.render();
      });

      for (const step of this.querySelectorAll('[data-ff-step]')) {
        step.addEventListener('click', () => {
          const delta = Number(step.dataset.ffStep);
          this.mutate('change', this.quantity() + delta);
        });
      }

      this.querySelector('[data-ff-remove]')?.addEventListener('click', () => this.mutate('change', 0));

      for (const name of ['cart:updated', 'ff:cart:updated']) {
        document.addEventListener(name, (event) => {
          const cart = event.detail?.cart || event.detail;
          if (cart && Array.isArray(cart.items)) this.sync(cart);
        });
      }

      this.claimPendingBoxAdd();
    }

    static PENDING_BOX_ADD_KEY = 'ff-pending-box-add';
    static PENDING_BOX_ADD_TTL = 10 * 60 * 1000;

    claimPendingBoxAdd() {
      if (!this.closest('[data-bb-staging]')) return;

      let pending = null;
      try {
        const raw = sessionStorage.getItem(FFProductCard.PENDING_BOX_ADD_KEY);
        if (!raw) return;
        pending = JSON.parse(raw);
      } catch (error) {
        return;
      }
      if (!pending || !pending.variantId) return;

      if (!pending.at || Date.now() - pending.at > FFProductCard.PENDING_BOX_ADD_TTL) {
        try { sessionStorage.removeItem(FFProductCard.PENDING_BOX_ADD_KEY); } catch (error) {}
        return;
      }

      let target = null;
      try {
        target = this.querySelector(`input[name="id"][value="${CSS.escape(String(pending.variantId))}"]`);
      } catch (error) {
        return;
      }
      if (!target) return;

      try { sessionStorage.removeItem(FFProductCard.PENDING_BOX_ADD_KEY); } catch (error) {}

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (target.type === 'radio' && !target.checked) {
            target.checked = true;
            this.render();
          }
          const already = Number(target.dataset.inCart || 0);
          this.mutate('add', already + Math.max(1, Number(pending.quantity) || 1));
        });
      });
    }

    // FAF001P-155: a card server-rendered with hide_actions true (the classic `customer`
    // object this store's New Customer Accounts setup never populates outside
    // /pages/account, see blocks/ff-plp.liquid's own correctSubscriptionStateIfWrong())
    // has no variant selector or actions markup at all -- `unless hide_actions` in the
    // template above omits them entirely, not just visually. When a caller inserts that
    // missing markup back in once a REAL client-side subscription check confirms it should
    // be there, connectedCallback() has already run and captured addBtn/box/qtyEl/etc. as
    // null and bound zero stepper click listeners against elements that didn't exist yet.
    // input()/quantity()/render() below all re-query the form fresh on every call, so they
    // need nothing extra -- only the once-captured element refs and the stepper listeners
    // need redoing, which is all this does. this.form's submit listener and the
    // document-level cart-sync listener were already bound to stable targets and keep
    // working unchanged.
    rebindActions() {
      this.addBtn = this.querySelector('[data-ff-add]');
      this.box = this.querySelector('[data-ff-box]');
      this.qtyEl = this.querySelector('[data-ff-qty]');
      this.priceEl = this.querySelector('[data-ff-price]');
      this.servesEl = this.querySelector('[data-ff-serves]');
      this.servesLabel = this.querySelector('[data-ff-serves-label]');
      this.errorEl = this.querySelector('[data-ff-error]');
      for (const step of this.querySelectorAll('[data-ff-step]')) {
        if (step.__ffStepBound) continue;
        step.__ffStepBound = true;
        step.addEventListener('click', () => this.mutate('change', this.quantity() + Number(step.dataset.ffStep)));
      }
      this.querySelector('[data-ff-remove]')?.addEventListener('click', () => this.mutate('change', 0));
      this.render();
    }

    input() {
      return this.form.querySelector('input[name="id"]:checked') || this.form.querySelector('input[name="id"]');
    }

    quantity() {
      return Number(this.input()?.dataset.inCart || 0);
    }

    render() {
      const input = this.input();
      if (!input) return;
      const qty = Number(input.dataset.inCart || 0);
      const inBox = qty > 0;

      this.classList.toggle('ff-product-card--in-box', inBox);
      this.addBtn?.toggleAttribute('hidden', inBox);
      this.box?.toggleAttribute('hidden', !inBox);
      if (this.qtyEl) this.qtyEl.textContent = String(qty);
      if (this.addBtn) this.addBtn.disabled = input.dataset.available === 'false';

      if (this.priceEl && input.dataset.price) this.priceEl.textContent = input.dataset.price;

      const serves = input.dataset.serves || '';
      if (this.servesEl) this.servesEl.toggleAttribute('hidden', serves === '');
      if (this.servesLabel && serves !== '') {
        const tpl = this.servesEl?.dataset.ffServesTemplate;
        if (tpl) this.servesLabel.textContent = tpl.replace(/\{\{\s*count\s*\}\}/g, serves);
      }
    }

    sync(cart) {
      if (!this.form || !cart || !Array.isArray(cart.items)) return;
      for (const input of this.form.querySelectorAll('input[name="id"]')) {
        const line = cart.items.find((item) => String(item.variant_id) === input.value);
        input.dataset.inCart = line ? String(line.quantity) : '0';
        input.dataset.lineKey = line ? line.key : '';
      }
      this.render();
    }

    async mutate(kind, quantity) {
      const input = this.input();
      if (!input) return;

      if (this.closest('[data-bb-staging]')) {
        const stagedQuantity = Math.max(0, quantity);
        input.dataset.inCart = String(stagedQuantity);
        this.render();
        this.dispatchEvent(new CustomEvent('ff:box-builder:stage', {
          bubbles: true,
          detail: {
            variantId: input.value,
            quantity: stagedQuantity,
            productId: input.dataset.productId,
            cardProductId: this.dataset.productId,
          },
        }));
        return;
      }

      // Checked BEFORE data-plp-subscription-write below, not after: a Christmas-tagged
      // card in blocks/ff-plp.liquid carries its OWN data-pdp-box-redirect on its immediate
      // wrapper (see that file's own comment on plp_is_christmas), pointed at the Christmas
      // Box builder instead of the regular one, specifically so a Christmas item never goes
      // into an existing subscription even for a real subscriber -- whose <ff-plp> ancestor
      // otherwise carries data-plp-subscription-write for every OTHER card on the same
      // page. closest() just returns the nearest match up the tree, so checking this first
      // means the per-card override (nearer) wins over the page-level flag (further) when
      // both exist; every other caller only ever has ONE of the two attributes present at
      // all (set once, mutually exclusively, on the single page-level element), so this
      // reorder changes nothing for them.
      const boxRedirect = this.closest('[data-pdp-box-redirect]');
      if (boxRedirect && kind === 'add') {
        try {
          sessionStorage.setItem(
            FFProductCard.PENDING_BOX_ADD_KEY,
            JSON.stringify({ variantId: String(input.value), quantity: Math.max(1, quantity), at: Date.now() })
          );
        } catch (error) {
        }
        window.location.href = boxRedirect.dataset.pdpBoxRedirect || '/products/your-box';
        return;
      }

      const subscriptionWrite = this.closest('[data-plp-subscription-write]');
      if (subscriptionWrite) {
        this.setBusy(true);
        this.setError('');
        const requestedQuantity = Math.max(0, quantity);
        subscriptionWrite.dispatchEvent(new CustomEvent('ff:plp:add-to-subscription', {
          bubbles: true,
          detail: {
            kind,
            productHandle: this.dataset.productHandle,
            productId: input.dataset.productId,
            variantId: input.value,
            quantity: requestedQuantity,
            onSuccess: (finalQuantity) => {
              input.dataset.inCart = String(
                Number.isFinite(finalQuantity) ? finalQuantity : requestedQuantity
              );
              this.render();
              this.setBusy(false);
            },
            onError: (message) => {
              this.setError(message || 'We could not add that to your box. Please try again.');
              this.setBusy(false);
            },
          },
        }));
        return;
      }

      this.setBusy(true);
      this.setError('');

      const key = input.dataset.lineKey;
      const isChange = kind === 'change' && key;
      const url = isChange ? '/cart/change.js' : '/cart/add.js';
      const sections = FFProductCard.cartSectionIds();
      const body = isChange
        ? { id: key, quantity: Math.max(0, quantity) }
        : { id: Number(input.value), quantity: Math.max(1, quantity) };
      if (sections.length) body.sections = sections.join(',');

      let response;
      try {
        response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
      } catch (transportError) {
        this.setError('');
        this.setBusy(false);
        if (!this.__ffSubmitting) { this.__ffSubmitting = true; this.form.submit(); }
        return;
      }

      try {
        const payload = await response.json();

        if (!response.ok) {
          this.setError(payload.description || payload.message || '');
          return;
        }

        const cart = Array.isArray(payload.items) ? payload : await (await fetch('/cart.js')).json();

        this.constructor.syncAll(cart);
        try {
          this.broadcast(cart, payload.sections, kind, quantity);
        } catch (broadcastError) {
          console.error('ff-product-card: a cart:lines-update listener threw', broadcastError);
        }
      } catch (afterResponseError) {
        console.error('ff-product-card: cart mutation failed after response', afterResponseError);
        this.setError(this.dataset.ffErrorText || '');
      } finally {
        this.setBusy(false);
      }
    }

    static syncAll(cart) {
      for (const card of document.querySelectorAll('ff-product-card')) {
        try { card.sync?.(cart); } catch (_) {  }
      }
    }

    broadcast(cart, sections, kind, quantity) {
      const action = kind === 'add' ? 'add' : quantity === 0 ? 'remove' : 'update';
      const event = new Event('shopify:cart:lines-update', { bubbles: true });
      event.action = action;
      event.context = 'product';
      event.promise = Promise.resolve({
        cart: { totalQuantity: cart.item_count },
        detail: { itemCount: cart.item_count, sections },
      });
      document.dispatchEvent(event);

      document.dispatchEvent(new CustomEvent('ff:cart:updated', { detail: { cart } }));
    }

    static cartSectionIds() {
      const ids = new Set();
      for (const el of document.querySelectorAll('[data-section-id]')) {
        if (el.closest('cart-items-component, cart-drawer-component, cart-icon') || el.matches('cart-items-component, cart-drawer-component, cart-icon')) {
          if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
        }
      }
      return [...ids];
    }

    setBusy(busy) {
      this.toggleAttribute('data-busy', busy);
      this.toggleAttribute('aria-busy', busy);
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.toggleAttribute('hidden', !message);
    }
  }

  if (!customElements.get('ff-product-card')) customElements.define('ff-product-card', FFProductCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ff-quickview"] && !Shopify.designMode) return;
  try {
    class FFQuickview extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-quickview-dialog]');
      this.body = this.querySelector('[data-quickview-body]');
      if (!this.dialog) return;

      this.host = this.parentElement;
      this.host?.addEventListener('ff:product-card:quick-view', (event) => {
        this.open(event.detail.productId);
      });

      this.querySelector('[data-quickview-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.body.replaceChildren());
    }

    open(productId) {
      const template = this.host?.querySelector(`[data-quickview-content][data-product-id="${productId}"]`);
      if (!template) return;

      this.body.replaceChildren(template.content.cloneNode(true));
      this.syncFromGrid();
      this.dialog.showModal();
      this.refreshReviewsWidget();
    }

    syncFromGrid() {
      const card = this.body.querySelector('ff-product-card');
      if (!card || !this.host) return;

      let painted = false;
      for (const input of this.body.querySelectorAll('input[name="id"]')) {
        if (!input.value) continue;
        let live = null;
        try {
          const candidates = this.host.querySelectorAll(
            `input[name="id"][value="${CSS.escape(input.value)}"]`
          );
          for (const candidate of candidates) {
            if (this.contains(candidate)) continue;
            live = candidate;
            break;
          }
        } catch (error) {
          continue;
        }
        if (!live) continue;
        input.dataset.inCart = live.dataset.inCart || '0';
        if (live.dataset.lineKey !== undefined) input.dataset.lineKey = live.dataset.lineKey;
        painted = true;
      }
      if (painted && typeof card.render === 'function') card.render();
    }

    refreshReviewsWidget() {
      if (typeof window.ratingSnippet !== 'function') return;
      const store = window.__REVIEWSIO_RATING_SNIPPET_STORE_OVERRIDE__ || window.reviewsIoStore;
      if (!store) return;
      if (!this.body.querySelector('.ruk_rating_snippet')) return;

      try {
        window.ratingSnippet('ruk_rating_snippet', {
          store,
          color: '#000',
          textClr: '#333',
          linebreak: false,
          usePolaris: true,
          text: 'Reviews',
          lang: window.reviewsIoLang || 'en',
          mode: 'default',
          showEmptyStars: false,
          enableSyndication: window.reviewsIoEnableSyndication || false,
        });
      } catch (error) {
      }
    }

  }

  if (!customElements.get('ff-quickview')) customElements.define('ff-quickview', FFQuickview);
  } catch(e) { console.error(e); }
})();

})();
